import Router from "vue-router";
// Create the router instance and pass the `routes` option
// open page in new tab
Router.prototype.open = function({ name = "", path = "", query = null, params = null, type = null }) {
  let host = window.location.origin;
  let queryString = "?";
  let urn = "";
  if (name) {
    urn = this.options.routes ? this.options.routes.find((val) => val.name == name).path : "";
  } else if (path) {
    urn = path;
  } else {
    console.error("Error:[Router.open] missed path or router name");
  }
  if (query) {
    for (const i in query) {
      queryString += i + "=" + query[i] + "&";
    }
    queryString = queryString.slice(0, queryString.length - 1);
  }
  if (params) {
    for (const i in params) {
      urn = urn.replace(`:${i}`, params[i]);
    }
  }
  if (type === "excel") {
    host = global.apiUrl.replace('/api/web', '');
  }
  console.log(host);
  window.open(host + urn + (query ? queryString : ""));
};

export default Router;
